import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { UpdateCheckComponent } from './update-check/update-check.component';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from './app.module';
// import { NoRightClickDirective } from './directives/no-right-click.directive';
// import { HideMissingDirective } from './directives/handle-missing-img';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    // NoRightClickDirective,
    // HideMissingDirective,
    UpdateCheckComponent
  ],
  exports: [ 
    // NoRightClickDirective,
    // HideMissingDirective,
    UpdateCheckComponent
   ],
  entryComponents: []
})
export class CheckSuggestModule {}
